import { EKeyCode } from '@/enums/e_key_code';
import { use_shortcut_down } from '@/hooks/shortcuts/use_shortcut_down';

interface Props {
  key_code: EKeyCode;
  on_workspace_selected: (workspace_id: string, is_used_shortcut?: boolean) => void;
  workspace_id: string;
}

export function WatcherShortcutWorkspaceNavigation({ key_code, on_workspace_selected, workspace_id }: Props) {
  use_shortcut_down([key_code], on_shortcut_pressed);

  function on_shortcut_pressed() {
    on_workspace_selected(workspace_id);

    return true;
  }

  return null;
}
